// extracted by mini-css-extract-plugin
export default {"primayButtonWrapper":"_27PzYiKXEsQGz4hCsCUwGG","secondaryButtonWrapper":"_3z2j3LAhGq29TfOTQfwzml","buttonWrapperDisabled":"_2pqbmtpnMIvdX4gXhFUVht"};